import React, { Component } from "react";
import Alice from "../Display/Alice";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import SidebarAttribute from "./AttributePropertyPanel";
import { Splitter } from "@progress/kendo-react-layout";
import AttributeTypes from "./AttributeTypes";
import Loader from "../Shared/Loader/loader";
import CreateAttributeDialog from "./CreateAttributeDialog";
import RemoveDialog from "../Shared/Remove/RemoveDialog";
import SelectAttributeTemplate from "./SelectAttributeTemplate";
import { Checkbox } from "@progress/kendo-react-inputs";
import Scrollable from "../Shared/Edit/Scrollable";
import { updateNode } from "../Helpers/Nodes";
import { callApiWithAuthorization } from "../../API/CallApi";
import Upgarde from "../Shared/Subscription/Upgrade";
import ServerError from "../Shared/Error/ServerError";
import { GlobalContext } from "../../Renderers/GlobalContext";
import { NotificationGroup, Notification } from "@progress/kendo-react-notification";
import { useNavigate } from 'react-router-dom';
import { ATTRIBUTE_LABEL, ATTRIBUTE_PLURAL_LABEL } from "../Helpers/Labels/AttributeLabel";
import WorkspaceAppModelContext from "../../Context/Workspace/WorkspaceAppModelContext";
import AliceAttributeRecommendationDialog from "./AttributeRecommendation/AliceAttributeRecommendationDialog";
import { bulkDeleteAttributes, deleteAttribute, getAttributes, saveStatesForAttribute, findFormulaReferencesForAttribute, getStatesAndRulesForAttribute, updateAttributeNode } from "../../API/Attribute/Attribute";
import { getAllAttributes } from "../Helpers/Schema/Schema";
import SelectSharedProperty from "./SelectSharedProperty";
import CreateSharedPropertyDialog from "./CreateSharedPropertyDialog";
import { withTranslation } from "react-i18next";
import { getProjectRoles } from "../../API/Role/Role";
import { updateProject } from "../../API/Project/project";

class DragCell extends React.Component {
    render() {
        return (
            <td
                className="dragCell"
                onDragOver={(e) => {
                    DragCell.reorder(this.props.dataItem);
                    e.preventDefault();
                    e.dataTransfer.dropEffect = "copy";
                }}
                onDragEnd={(e) => {
                    e.preventDefault();
                    DragCell.endDrag(this.props.dataItem);
                }}
            >
                <span
                    draggable="true"
                    style={{ cursor: "move" }}
                    onDragStart={(e) => {
                        DragCell.dragStart(this.props.dataItem);
                        e.dataTransfer.setData("dragging", "");
                    }}
                >
                    {this.props.dataItem["#"]}
                </span>
            </td>
        );
    }
}

class SelectAllCheckbox extends React.Component {
    render() {
        const { data, onClick } = this.props;
        const isNormalAttributePresent = data.some(item => !item.isSystemAttribute && !item.isAzureAttribute);
        const normalAttributes = data.filter((item) => !item.isSystemAttribute && !item.isAzureAttribute);
        const allMarkedToDelete = normalAttributes.length ? normalAttributes.every((item) => item.toDelete === true) : false;
        return (
            <Checkbox
                disabled={!isNormalAttributePresent}
                className="k-checkbox-no-spacing"
                checked={allMarkedToDelete}
                onChange={onClick}
            />
        );
    }
}

class NameCell extends React.Component {
    render() {
        const { dataItem } = this.props;

        let prefix = "";

        if (dataItem.inherited) {
            prefix = "(i)";
        }

        if (dataItem.groupAdded && dataItem.inherited) {
            if (dataItem.inheritedFrom === true) {
                prefix = <span>(ia)</span>;
            } else {
                prefix = (
                    <span
                        className="link"
                        onClick={() => this.props.showEditRelName(dataItem)}
                    >
                        (ia)
                    </span>
                );
            }
        }

        return (
            <td title={dataItem.attributeName}>
                {dataItem.attributeName} {prefix}
            </td>
        );
    }
}

class AttributeComponent extends Component {

    DataTypes = AttributeTypes.Types;
    Icons = AttributeTypes.Icons;

    static contextType = GlobalContext
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            isAttrLoaded: false,
            showReorderingSysAttrMessage: false,
            showNewAttributeDialog: false,
            ShowNotification: false,
            ShowNotificationMessage: "",
            showSelectAttributeTemplate: false,
            showSelectSharedPropertyDialog: false,
            showCreateSharedPropertyDialog: false,
            showUpgradeDailog: false,
            panes: [
                { collapsible: false },
                { size: "475px", min: "475px", collapsible: false },
            ],
            data: [],
            sharedProperties: [],
            ShowHelp: false,
            SideData: {},
            processingAttribute: false,
            nextAttributeId: "",
            showServerError: false,
            referenceAttr: [],
            roles: [],
            referenceChecked: false,
            showAliceGPTDialog: false,
            showBulkDeleteDialog: false,
        };
        this.SidebarAttribute = React.createRef();
        DragCell.reorder = this.reorder.bind(this);
        DragCell.dragStart = this.dragStart.bind(this);
        DragCell.endDrag = this.endDrag.bind(this);
        AttributeTypes.bindEvents();
    }

    componentDidMount = async () => {
        await this.loadAttribute();
    };
    loadAttribute = async (currentAttributeId = "") => {

        try {
            this.setState({ isAttrLoaded: false });
            const showSystemAttributes = this.getShowSystemAttributesValue();
            const [
                allAttributes, roles,
            ] = await Promise.all([
                this.getAllAttributes(),
                getProjectRoles(this.props.project._id),
            ])
            let data = [];
            if (showSystemAttributes) {
                data = this.arrangeSystemAttributesFrom(allAttributes);
            } else {
                data = allAttributes.filter(attr => !attr.isSystemAttribute).sort((a, b) => a.order - b.order);
            }
            const loading = false;
            this.setState(
                {
                    allAttributes,
                    data,
                    loading,
                    roles,
                    showSystemAttributes
                },
                () => {
                    if (this.state.data.length > 0) {
                        if (this.props.selectedSysName) {
                            let toSelectAttribute = this.state.data.find(
                                (attr) =>
                                    attr.sysName === this.props.selectedSysName
                            );
                            if (toSelectAttribute) {
                                this.rowClick(toSelectAttribute._id);
                            } else {
                                this.rowClick(this.state.data[0]._id);
                            }
                        } else {
                            if (this.state.selectedId && this.state.selectedId.length > 0) {
                                if (currentAttributeId !== this.state.selectedId) {
                                    this.rowClick(this.state.selectedId);
                                }
                            }
                            else {
                                this.rowClick(this.state.data[0]._id);
                            }
                        }
                    }
                    this.props.onLoadingComplete();
                }
            );
            document.addEventListener("click", this.handlePopup);
        } catch (error) {
            debugger
            console.error(error)
            this.setState({ showServerError: true })
        }
    }

    getShowSystemAttributesValue = () => {
        const { entityId } = this.props;
        const entityConfigLocalStorageString = localStorage.getItem("entity-config");
        const entityConfig = entityConfigLocalStorageString === null ? {} : JSON.parse(entityConfigLocalStorageString);
        if (entityConfig !== undefined && entityConfig[entityId] !== undefined) {
            return entityConfig[entityId]["showSystemAttribute"];
        }
        return false;
    };

    arrangeSystemAttributesFrom = (allAttributes) => {
        const normalAttributes = [];
        const systemAttributes = [];
        for (const attribute of allAttributes) {
            if (attribute.isSystemAttribute) {
                systemAttributes.push(attribute);
            } else {
                normalAttributes.push(attribute);
            }
        }
        const unOrderedSystemAttributes = systemAttributes
            .filter((attr) => attr.isReordered === false)
            .sort((a, b) => a.order - b.order);
        const orderedSystemAttributes = systemAttributes
            .filter((attr) => attr.isReordered === true)
            .sort((a, b) => a.order - b.order);
        let attributes = [...normalAttributes];
        if (orderedSystemAttributes.length > 0) {
            attributes.push(...orderedSystemAttributes);
            attributes = attributes.sort((a, b) => a.order - b.order);
        }
        attributes.push(...unOrderedSystemAttributes)
        return attributes;
    }

    rowRender = (trElement, props) => {
        const trProps = { className: "k-master-row" };
        if (props.dataItem.selected) {
            trProps.className += " k-state-selected";
        }
        if (props.dataItem.isHovered) {
            if (this.state.activeItemIndex > this.state.draggedOverItemIndex) {
                trProps.className = " hovered-row-above";
            } else {
                trProps.className = " hovered-row-below";
            }
        }
        return React.cloneElement(trElement, trProps, trElement.props.children);
    };

    getInitialHeightForWindow = () => {
        // return 80% of the window height
        return window.innerHeight * 0.8;
    };

    getInitialWidthForWindow = () => {
        // return 75% of the window width
        return window.innerWidth * 0.75;
    };

    getDeleteAttributeDialogMessage = () => {
        const index = this.state.data.findIndex(attr => attr._id === this.state.toDeleteId);
        const attribute = this.state.data[index];
        if (attribute.attributeType === "Entity Lookup") {
            return this.props.t("remove_dialog.warning_with_entity_lookup", {
                attributeName: this.state.SideData.attributeName
            })
        }
        if (this.state.referenceAttr && this.state.referenceAttr.length > 0) {
            return this.props.t("remove_dialog.warning_with_reference_attr", {
                attributeName: this.state.SideData.attributeName
            })
        }
        return this.props.t("remove_dialog.warning_without_reference_attr", {
            attributeName: this.state.SideData.attributeName
        })
    }

    render() {
        const { subscription } = this.context.state
        if (this.state.showServerError) return <ServerError />
        let sideData;

        if (this.state.data.length > 0) {
            sideData = (
                <WorkspaceAppModelContext.Consumer>
                    {
                        ({ state, mutators }) => (
                            <SidebarAttribute
                                subscription={this.props.subscription}
                                useSuspense={false}
                                roles={this.state.roles}
                                isInternalUser={this.props.isInternalUser}
                                developerMode={this.props.project.developerMode}
                                attributes={this.state.allAttributes}
                                projectName={this.props.project.name}
                                organisationId={this.props.organization._id}
                                sysName={this.props.sysName}
                                orgName={this.props.organization.orgName}
                                project={this.props.project}
                                entityId={this.props.entityId}
                                entityName={this.props.entityName}
                                SideData={this.state.SideData}
                                // EntityData={this.state.EntityData}
                                onDelete={this.showDeleteAttributePopup}
                                updateAttribute={this.updateAttribute}
                                ShowNotification={this.handleShowNotification}
                                selectNextAttribute={this.selectNextAttribute}
                                clearNextAttribute={this.clearNextAttribute}
                                loadAttribute={this.loadAttribute}
                                ref={this.SidebarAttribute}
                                isAttrLoaded={this.state.isAttrLoaded}
                                mutators={mutators}
                                isUserEntity={this.props.isUserEntity}
                            />
                        )
                    }
                </WorkspaceAppModelContext.Consumer>
            );
        } else {
            sideData = <div></div>;
        }

        if (this.state.loading) {
            return <Loader />;
        }

        const { t } = this.props;

        return (
            <>
                {
                    this.state.showUpgradeDailog &&
                    <Upgarde
                        organization={this.props.organization}
                        Headline={'Need to build <br/> bigger apps? '}
                        toggleDialog={this.toggleUpgradeDailog}
                        Type={'Pro'}
                    />
                }
                {this.state.showNewAttributeDialog && (
                    <CreateAttributeDialog
                        advancedMode={this.props.project.developerMode}
                        entityId={this.props.entityId}
                        entityName={this.props.entityName}
                        orgName={this.props.organization.orgName}
                        organisationId={this.props.organization._id}
                        subscriptionId={this.props.organization.subscriptionId}
                        projectId={this.props.project._id}
                        projectName={this.props.project.name}
                        selectedSysName={this.props.selectedSysName}
                        sysName={this.props.sysName}
                        showNewAttributeDialog={this.state.showNewAttributeDialog}
                        data={this.state.data}
                        allAttributes={this.state.allAttributes}
                        closeDialog={this.toggleDialog}
                        onCreate={this.createAttribute}
                    />
                )}
                {
                    this.state.showAliceGPTDialog &&
                    <AliceAttributeRecommendationDialog
                        organization={this.props.organization}
                        organizationId={this.props.organization._id}
                        project={this.props.project}
                        entityId={this.props.entityId}
                        entityName={this.props.entityName}
                        existingAttributeNames={this.getExistingAttributeNames()}
                        toggleDialog={this.toggleAliceGPTDialog}
                        onAttributesImported={this.addImportAttributesToGrid}
                        hasStateAttribute={this.hasStateAttribute()} />
                }
                {this.state.showDeletePopup && (
                    <RemoveDialog
                        showLoader={this.state.processingAttribute}
                        loading={this.state.processingAttribute}
                        toggleDeleteDialog={this.toggleDeleteAttributeDialog}
                        onDelete={this.deleteAttribute}
                        message={this.getDeleteAttributeDialogMessage()}
                        Title={t("remove_dialog.title")}
                        cancelButtonText={t("remove_dialog.buttons.cancel_label")}
                        deleteButtonText={t("remove_dialog.buttons.delete_label")}
                        referenceAttr={this.state.referenceAttr}
                        process={{
                            inProcess: !this.state.referenceChecked
                        }}
                        currentEntity={this.props.entityId}
                        orgName={this.props.organization.orgName}
                        projectName={this.props.project.name}
                        focusAttribute={this.focusAttribute}
                    />
                )}
                {this.state.showSelectAttributeTemplatePopup && (
                    <SelectAttributeTemplate
                        useSuspense={false}
                        entityId={this.props.entityId}
                        organization={this.props.organization}
                        project={this.props.project}
                        selectedSysName={this.props.selectedSysName}
                        sysName={this.props.sysName}
                        showNewAttributeDialog={this.state.showNewAttributeDialog}
                        data={this.state.data}
                        allAttributes={this.state.allAttributes}
                        onSelect={this.createAttribute}
                        closeDialog={this.showSelectAttributeTemplate}
                    />
                )}
                {this.state.showSelectSharedPropertyDialog && (
                    <SelectSharedProperty
                        updatedSharedProperties={this.updateSharedPropertyAttribute}
                        project={this.props.project}
                        entityId={this.props.entityId}
                        subscriptionId={this.props.organization.subscriptionId}
                        attributes={this.state.data}
                        onCreateSharedProperty={this.createSharedProperty}
                        removeSharedPropertyAttribute={this.removeSharedPropertyAttribute}
                        handleClose={this.showSelectSharedProperty}
                        openCreateSharedPropertyDialog={this.openCreateSharedProperty}
                    />
                )}
                {this.state.showCreateSharedPropertyDialog && (
                    <CreateSharedPropertyDialog
                        updatedSharedProperties={(data) => this.setState({ sharedProperties: data })}
                        sharedProperties={this.state.sharedProperties}
                        projectId={this.props.project._id}
                        handleClose={this.showCreateSharedProperty}
                    />
                )}
                {this.state.data.length === 0 ? (
                    <Alice mode="new" header={`Create ${ATTRIBUTE_LABEL}`}>
                        {t("no_data_message.message_1")}
                        <br /><br />
                        {t("no_data_message.click_on")}
                        <b className="mx-1">
                            {t("no_data_message.bold_text")}
                        </b>
                        {t("no_data_message.add_properties")}
                    </Alice>
                ) : (
                    <Splitter
                        className="h-100"
                        panes={this.state.panes}
                        onChange={this.onSplitterSizeChange}
                    >
                        <div className="d-flex flex-column h-100">
                            <div className="text-end">
                                {this.state.ShowNotification && (
                                    <NotificationGroup style={{
                                        top: this.props.isAccessedFromWorkspace ? 65 : 45,
                                        left: "50%",
                                        transform: "translateX(-50%)",
                                        zIndex: 10
                                    }}>
                                        <Notification
                                            key="success"
                                            closable={true}
                                            onClose={() => {
                                                this.setState({
                                                    ShowNotification: false,
                                                    ShowNotificationMessage: ""
                                                })
                                            }}
                                            type={{
                                                style: "success",
                                                icon: true,
                                            }}
                                        >
                                            {this.state.ShowNotificationMessage}
                                        </Notification>
                                    </NotificationGroup>
                                )}

                            </div>
                            {this.state.loading && <Loader />}
                            {this.state.loading === false &&
                                this.state.data.length !== 0 && (
                                    <Scrollable>
                                        <div className="flex-row d-flex justify-content-between">
                                            {
                                                this.state.showReorderingSysAttrMessage ? (
                                                    <div className="alert alert-warning">
                                                        You cannot reorder system {ATTRIBUTE_PLURAL_LABEL.toLowerCase()}.
                                                    </div>
                                                ) : <div></div>
                                            }
                                        </div>
                                        {
                                            this.state.showBulkDeleteDialog &&
                                            <RemoveDialog
                                                Title={t("bulk_remove_dialog.title")}
                                                loading={this.state.processingAttribute}
                                                showLoader={this.state.processingAttribute}
                                                toggleDeleteDialog={this.toggleBulkDeleteDialog}
                                                message={
                                                    this.state.referenceBulkAttr && this.state.referenceBulkAttr.length > 0 ?
                                                        t("bulk_remove_dialog.warning_with_reference_attr", {
                                                            count: this.state.data.filter((item) => item.toDelete === true).length
                                                        }) :
                                                        t("bulk_remove_dialog.warning_without_reference_attr", {
                                                            count: this.state.data.filter((item) => item.toDelete === true).length
                                                        })
                                                }
                                                onDelete={this.handleBulkDelete}
                                                onCancel={this.toggleBulkDeleteDialog}
                                                deleteButtonText={t("bulk_remove_dialog.buttons.delete_label")}
                                                cancelButtonText={t("bulk_remove_dialog.buttons.cancel_label")}
                                            />
                                        }
                                        <Grid
                                            data={this.state.data.map(
                                                (item, index) => ({
                                                    ...item,
                                                    "#": index + 1,
                                                    selected: item._id === this.state.selectedId,
                                                    isHovered: index === this.state.draggedOverItemIndex, index,
                                                })
                                            )}
                                            onRowClick={this.rowClick}
                                            scrollable={false}
                                            selectedField="selected"
                                        >
                                            <Column width={40}
                                                cell={(props) => (
                                                    <td>
                                                        <Checkbox
                                                            disabled={props.dataItem.isSystemAttribute || props.dataItem.isAzureAttribute}
                                                            checked={props.dataItem.toDelete}
                                                            onChange={(e) => this.handleBulkDeleteSelection(e, props.dataItem)}
                                                        />
                                                    </td>

                                                )}
                                                headerCell={() => (
                                                    <SelectAllCheckbox
                                                        data={this.state.data}
                                                        onClick={this.handleSelectAllBulkDelete}
                                                    />
                                                )}
                                            />
                                            <Column field="#" title="#" width={50} cell={DragCell} />
                                            <Column
                                                field="attributeName"
                                                title={t("grid.header.name")}
                                                cell={(props) => (
                                                    <>
                                                        <NameCell
                                                            dataItem={props.dataItem}
                                                            showEditRelName={this.showEditRelName}
                                                        />
                                                    </>
                                                )}
                                            />
                                            <Column
                                                field="attributeType"
                                                title={t("grid.header.type")}
                                                cell={(props) => (
                                                    <td>
                                                        <i style={{ width: 25 }} className={`${this.Icons[props.dataItem.attributeType]} pe-1 text-center`}></i>
                                                        {
                                                            props.dataItem.typeText
                                                        }
                                                        {(
                                                            subscription.showCalculatedField &&
                                                            props.dataItem.triggerSetting && JSON.parse(props.dataItem.triggerSetting).formulaEnabled &&
                                                            props.dataItem.formula &&
                                                            props.dataItem.formula.length > 0
                                                        ) &&
                                                            <> (calculated)</>
                                                        }
                                                    </td>
                                                )}
                                            />

                                            <Column
                                                field="attributeLabel"
                                                title={t("grid.header.label")}
                                                cell={(props) => (
                                                    <td title={props.dataItem.attributeLabel}>
                                                        {props.dataItem.attributeLabel}
                                                    </td>
                                                )}
                                            />
                                            {/* <Column
                                                field="group"
                                                title="Section"
                                                cell={(props) => (
                                                    <td title={props.dataItem.group}>
                                                        {props.dataItem.group}
                                                    </td>
                                                )}
                                            /> */}
                                            <Column
                                                width={30}
                                                cell={(props) => (
                                                    <td className="pe-0 text-read">
                                                        {props.dataItem.required && <i title="Required" className="fas fa-circle required-circle" ></i>}
                                                    </td>
                                                )}
                                            />
                                            <Column
                                                width={15}
                                                cell={(props) => (
                                                    <td className="px-0 text-center">
                                                        {props.dataItem.readOnly && <i title="Read-Only" className="fas fa-circle readonly-circle" ></i>}
                                                    </td>
                                                )}
                                            />
                                            <Column
                                                width={30}
                                                cell={(props) => (
                                                    <td className="ps-0">
                                                        {props.dataItem.unique && <i title="Unique" className="fas fa-circle unique-circle" ></i>}
                                                    </td>
                                                )}
                                            />
                                        </Grid>
                                        <Checkbox
                                            className="sys-attr-checkbox"
                                            label={t("show_system_properties_text")}
                                            checked={this.state.showSystemAttributes}
                                            onChange={this.toggleSystemAttributes}>
                                        </Checkbox>
                                    </Scrollable>
                                )}
                        </div>
                        {sideData}
                    </Splitter>
                )
                }
            </>
        );
    }

    handleSelectAllBulkDelete = e => {
        const { data } = this.state;
        const updatedData = data.map(item =>
            (item.isSystemAttribute || item.isAzureAttribute) ? item : { ...item, toDelete: e.value }
        );
        const normalAttributes = updatedData.filter(item => !item.isSystemAttribute);
        const isAnySelected = normalAttributes.some(item => item.toDelete === true);
        this.props.showDeleteAction(isAnySelected);
        this.setState({ data: updatedData });
    };

    handleBulkDeleteSelection = (e, dataItem) => {
        const { data } = this.state;
        const selectedData = data.find(item => item._id === dataItem._id);
        selectedData.toDelete = e.value;
        const isAnySelected = data.some(item => item.toDelete === true);
        this.props.showDeleteAction(isAnySelected);
        this.rowClick(dataItem._id);
        this.setState({ data });
    }

    handleBulkDelete = async () => {
        const { data, allAttributes } = this.state;
        const selectedAttributes = data.filter(item => item.toDelete);

        // find State Field Attribute Type in selected attributes and make a call to save the state field
        const stateFieldAttribute = selectedAttributes.find(item => item.attributeType === 'State Field');

        if (stateFieldAttribute) {
            // await saveStatesForAttribute({
            //     attributeId: stateFieldAttribute._id,
            //     statesToCreate: [],
            //     statesToUpdate: [],
            //     statesToDelete: stateFieldAttribute.statefield,
            // })
        }

        const selectedAttributeIds = selectedAttributes.map(item => item._id);

        if (selectedAttributeIds.length) {
            this.setState({ processingAttribute: true });
            try {
                const bulkDeleteResponse = await bulkDeleteAttributes(this.props.entityId, selectedAttributeIds)
                debugger;
                if (bulkDeleteResponse.status === "Success") {
                    this.deleteFormula();
                    await updateProject(this.props.project._id, { hasSchemaChanges: true });

                    const remainingAttributes = data.filter(item => !selectedAttributeIds.includes(item._id));
                    const remainingAllAttributes = allAttributes.filter(item => !selectedAttributeIds.includes(item._id));

                    this.setState({
                        processingAttribute: false,
                        data: remainingAttributes,
                        allAttributes: remainingAllAttributes,
                        SideData: remainingAttributes.length ? this.state.SideData : {},
                    }, () => {
                        if (remainingAttributes.length)
                            this.rowClick(remainingAttributes[remainingAttributes.length - 1]._id);
                    });

                    this.props.showAction(remainingAttributes.length !== 0);
                    this.props.showDeleteAction(false);
                }
            } catch (err) {
                console.log(err);
            } finally {
                this.setState({
                    showBulkDeleteDialog: false,
                    processingAttribute: false
                });
            }
        } else {
            this.setState({ showBulkDeleteDialog: false });
        }
    }

    deleteFormula = async () => {
        var referenceAttr = this.state.referenceAttr.length > 0 ? this.state.referenceAttr : this.state.referenceBulkAttr || [];
        for (let item of referenceAttr) {
            const attr = this.state.data.find(attribute => attribute._id === item.attributeId);

            if (attr) {
                const triggerSettingObj1 = JSON.parse(attr.triggerSetting);
                triggerSettingObj1.formulaEnabled = false;
                const updatedTriggerSettingStr1 = JSON.stringify(triggerSettingObj1);
                attr.triggerSetting = updatedTriggerSettingStr1;
                await updateAttributeNode(attr._id, {
                    formula: "",
                    formulaJson: "",
                    triggerSetting: updatedTriggerSettingStr1,
                    readOnly: false
                })
                // await updateNode("Attribute", attr._id, attr);
                // callApiWithAuthorization("/api/v0/updateAttributeRoles", {
                //     method: "POST",
                //     headers: {
                //         "Content-Type": "application/json",
                //     },
                //     body: JSON.stringify({
                //         projectId: this.props.project._id,
                //         entityId: this.props.entityId,
                //         attributeId: attr._id,
                //         Value: "Edit",
                //     }),
                // });
            }

            const allEntityAttributes = await getAttributes(item.entityId);
            const linkedAttributes = allEntityAttributes.find(attrItem => attrItem._id === item.attributeId);

            if (linkedAttributes) {
                linkedAttributes.formula = '';
                linkedAttributes.formulaJson = '';
                const triggerSettingObj2 = JSON.parse(linkedAttributes.triggerSetting);
                triggerSettingObj2.formulaEnabled = false;
                const updatedTriggerSettingStr = JSON.stringify(triggerSettingObj2);
                linkedAttributes.triggerSetting = updatedTriggerSettingStr;
                linkedAttributes.readOnly = false;
                await updateAttributeNode(linkedAttributes._id, {
                    formula: "",
                    formulaJson: "",
                    triggerSetting: updatedTriggerSettingStr,
                    readOnly: false
                })
                // await updateNode("Attribute", linkedAttributes._id, linkedAttributes);
                // callApiWithAuthorization("/api/v0/updateAttributeRoles", {
                //     method: "POST",
                //     headers: {
                //         "Content-Type": "application/json",
                //     },
                //     body: JSON.stringify({
                //         projectId: this.props.project._id,
                //         entityId: this.props.entityId,
                //         attributeId: linkedAttributes._id,
                //         Value: "Edit",
                //     }),
                // });
            }
        }
    }


    toggleBulkDeleteDialog = async () => {
        this.setState({
            showBulkDeleteDialog: !this.state.showBulkDeleteDialog,
            processingAttribute: true
        });

        const { data } = this.state;
        const selectedAttributes = data.filter(item => item.toDelete);

        const filteredAttributes = selectedAttributes.filter(item =>
            item.attributeType === "DateTime" ||
            item.attributeType === "Number" ||
            item.attributeType === "String"
        );
        if (filteredAttributes && filteredAttributes.length > 0) {
            await this.checkBulkFormulaReferences(filteredAttributes);
        }
        this.setState({
            processingAttribute: false
        });
    }

    onSplitterSizeChange = (e) => {
        this.setState({ panes: e.newState });
    };

    getAllAttributes = async () => {
        let allAttributes = await getAttributes(this.props.entityId)

        for (let i = 0; i < allAttributes.length; i++) {
            const attribute = allAttributes[i];
            if (attribute.cellFormatting) {
                attribute.cellFormatting = JSON.parse(attribute.cellFormatting);
            }
        }
        debugger

        allAttributes.forEach(this.setAttributeProperties);

        let groups = allAttributes.map((attribute) => {
            if (!attribute.groupAdded) {
                return attribute.group;
            }
        }).filter((group) => group && group.trim() !== "");

        this.GroupData = [...new Set(groups)];

        allAttributes = allAttributes.sort((a, b) => a.order - b.order)
        debugger
        return allAttributes;
    };

    setAttributeProperties = (attributeData, index) => {
        if (attributeData.inherited === "true") {
            if (attributeData.relName && attributeData.relName.trim() !== "") {
                attributeData.groupAdded = true;
                attributeData.group = attributeData.relName;

                if (attributeData.inheritedFrom === "true") {
                    attributeData.inheritedFrom = true;
                }
            }

            attributeData.inherited = true;
        } else {
            attributeData.inherited = false;
        }

        attributeData.isSystemAttribute = attributeData.isSystemAttribute;
        // attributeData.indexId = index + 1;
        attributeData.typeText = attributeData.attributeType === "Entity Lookup"
            ? "Referenced Property"
            : this.DataTypes.find((type) => type.value === attributeData.attributeType) !== undefined ? this.DataTypes.find((type) => type.value === attributeData.attributeType).text : "Type not found";
        attributeData.isReordered = attributeData.isSystemAttribute && attributeData.isReordered === "true";
    };

    rowClick = (value) => {
        var id = "";

        this.setState({ isAttrLoaded: false });
        if (value["dataItem"]) {
            id = value.dataItem._id;
        } else {
            id = value;
        }

        let attributePropertiesAreSame = this.SidebarAttribute.current.getDisabled();
        let isAttributeDeleted = this.state.data.find(attribute => attribute._id === this.SidebarAttribute.current.props.SideData._id) === undefined;

        if (attributePropertiesAreSame || isAttributeDeleted) {
            let nextAttribute = this.state.data.find(
                (attribute) => attribute._id === id
            );

            this.setState({
                ShowNotification: false,
                selectedId: id,
                SideData: nextAttribute,
                nextAttributeId: "",
            });
        } else {
            this.SidebarAttribute.current.toggleSaveAndContinueDialog();
            this.setState({
                nextAttributeId: id,
                ShowNotification: false
            });
        }
        this.setState({ isAttrLoaded: true });
    };

    selectNextAttribute = (e) => {
        let { data, nextAttributeId } = this.state;
        const nextAttribute = data.find(
            (attribute) => attribute._id === nextAttributeId
        );
        this.setState({
            selectedId: nextAttributeId,
            SideData: nextAttribute,
            nextAttributeId: "",
        });
    };

    clearNextAttribute = (e) => {
        this.setState({
            nextAttributeId: "",
        });
    };

    addNew = (e) => {
        this.setState({
            showNewAttributeDialog: true,
        });
    };

    toggleDialog = (showUpgradeDailog) => {
        this.setState({
            showUpgradeDailog: showUpgradeDailog,
            showNewAttributeDialog: false,
        });
    };

    toggleUpgradeDailog = () => {
        this.setState({
            showUpgradeDailog: !this.state.showUpgradeDailog
        })
    }

    //select attribute Template Dialog
    showSelectAttributeTemplate = (showUpgradeDailog) => {
        this.setState({
            showUpgradeDailog: showUpgradeDailog,
            showSelectAttributeTemplatePopup: !this.state.showSelectAttributeTemplatePopup,
        });
    };

    //select shared property Dialog
    showSelectSharedProperty = (showUpgradeDailog) => {
        this.setState({
            showUpgradeDailog: showUpgradeDailog,
            showSelectSharedPropertyDialog: !this.state.showSelectSharedPropertyDialog,
        });
    };

    // open create shared property Dialog
    openCreateSharedProperty = () => {
        this.setState({
            showCreateSharedPropertyDialog: true,
            showSelectSharedPropertyDialog: false,
        });
    };

    //create shared property Dialog
    showCreateSharedProperty = (showSelectSharedPropertyDialog) => {
        this.setState({
            showCreateSharedPropertyDialog: !this.state.showCreateSharedPropertyDialog,
            showSelectSharedPropertyDialog: showSelectSharedPropertyDialog,
        });
    }

    // System Attributes
    toggleSystemAttributes = (e) => {
        let { allAttributes, data, showSystemAttributes } = this.state;
        showSystemAttributes = !showSystemAttributes;
        const isSystemAttributeCurrentlySelected = data.find(
            (attr) => attr._id === this.state.selectedId && attr.isSystemAttribute
        );

        if (showSystemAttributes) {
            const systemAttributes = allAttributes.filter(
                (attr) => attr.isSystemAttribute
            );
            const unOrderedSystemAttributes = systemAttributes
                .filter((attr) => attr.isReordered === false)
                .sort((a, b) => a.order - b.order);
            const orderedSystemAttributes = systemAttributes
                .filter((attr) => attr.isReordered === true)
            if (orderedSystemAttributes.length > 0) {
                data = [...data, ...orderedSystemAttributes];
                data = data.sort((a, b) => a.order - b.order);
            }
            data = [...data, ...unOrderedSystemAttributes];
        } else {
            data = data.filter((attr) => !attr.isSystemAttribute);
        }
        this.syncValueInLocalStorage(e.target.element.checked);

        // data = data.map((attr, i) => ({ ...attr, _id: i + 1 }));

        this.setState(
            {
                allAttributes,
                data,
                showSystemAttributes,
            },
            () => {
                if (data.length > 0) {
                    if (isSystemAttributeCurrentlySelected) {
                        this.rowClick(data[0]._id);
                    }
                } else {
                    this.setState({
                        selectedId: "",
                        SideData: {},
                    });
                }
            }
        );
    };

    syncValueInLocalStorage = (value) => {
        const { entityId } = this.props;
        const localStorageValue = localStorage.getItem("entity-config");
        const localStorageValueJSON =
            localStorageValue === null ? {} : JSON.parse(localStorageValue);
        if (localStorageValueJSON[entityId] === undefined) {
            localStorageValueJSON[entityId] = {};
        }
        localStorageValueJSON[entityId]["showSystemAttribute"] = value;
        const newLocalStorageValue = JSON.stringify(localStorageValueJSON);
        localStorage.setItem("entity-config", newLocalStorageValue);
    };

    handlePopup = (e) => {
        const { anchor, popupContainer } = this;
        const { showPopup } = this.state;
        const { target } = e;

        if (
            showPopup &&
            !anchor.contains(target) &&
            !popupContainer.contains(target)
        ) {
            this.setState({
                showPopup: false,
            });
        }
    };

    handleShowNotification = (message) => {
        this.setState({
            ShowNotification: true,
            ShowNotificationMessage: message
        })
        setTimeout(() => {
            this.setState({
                ShowNotification: false,
                ShowNotificationMessage: ""
            })
        }, 2000)
    }

    showOtherOptionsPopup = () => {
        this.setState({
            showPopup: !this.state.showPopup,
        });
    };

    componentWillUnmount() {
        document.removeEventListener("click", this.handlePopup);
    }

    // Re-ordering Part
    reorder(dataItem) {
        if (this.state.activeItem._id === dataItem._id) {
            if (
                this.state.activeItemIndex !== this.state.draggedOverItemIndex
            ) {
                this.setState({ draggedOverItemIndex: -1 });
            }
            return;
        }

        let draggedOverItemIndex = this.state.data.findIndex(
            (p) => p._id === dataItem._id
        );

        this.setState({
            activeItem: this.state.activeItem,
            draggedOverItemIndex,
        });
    }

    updateOrder = (_id, ordertoUpdate, sysName) => {

        let properties = { order: ordertoUpdate, sysName: sysName };

        // callApiWithAuthorization("/api/v0/relationships", {
        //     method: "PUT",
        //     headers: {
        //         "Content-Type": "application/json",
        //     },
        //     body: JSON.stringify({
        //         id: _id,
        //         label: "Has_Attribute",
        //         properties: properties,
        //     }),
        // });
    };

    endDrag(dataItem) {
        if (dataItem.isSystemAttribute === true) {
            this.setState({
                showReorderingSysAttrMessage: true
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showReorderingSysAttrMessage: false
                    });
                }, 3000);
            });
            return;
        }

        let { activeItemIndex, draggedOverItemIndex, showSystemAttributes } =
            this.state;

        if (draggedOverItemIndex === -1) {
            // this.setState({
            //     selectedId: this.state.oldSelectedId,
            //     draggedOverItemIndex,
            //     activeItemIndex,
            // });
            return;
        }

        if (this.state.data[draggedOverItemIndex].isSystemAttribute === true) {
            this.setState(
                {
                    showReorderingSysAttrMessage: true,
                },
                () => {
                    setTimeout(() => {
                        this.setState({
                            showReorderingSysAttrMessage: false,
                        });
                    }, 3000);
                }
            );
            return;
        }

        let reorderedData = this.state.data.slice();

        const activeItem = reorderedData[activeItemIndex];
        if (activeItem.isSystemAttribute === true) {
            updateAttributeNode(activeItem._id, { isReordered: true });
            // updateNode("Attribute", activeItem._id, { isReordered: true });
            reorderedData[activeItemIndex].isReordered = true;
        }

        reorderedData.splice(activeItemIndex, 1);
        reorderedData.splice(draggedOverItemIndex, 0, this.state.activeItem);
        let index = draggedOverItemIndex;

        let newOrder;

        if (reorderedData.length > 2) {
            if (index === reorderedData.length - 1) {
                newOrder = parseInt(reorderedData[index - 1]["order"]) + 10000000000;
                reorderedData[index]["order"] = newOrder;
                updateAttributeNode(reorderedData[index]._id, {
                    order: String(newOrder)
                });
                // this.updateOrder(
                //     reorderedData[index].rel_id,
                //     newOrder,
                //     reorderedData[index].sysName
                // );
            } else if (index === 0) {
                newOrder = parseInt(reorderedData[1]["order"]);
                let prevElementOrder = parseInt(reorderedData[2]["order"]);
                if (reorderedData[2].isSystemAttribute === true) {
                    prevElementOrder += newOrder;
                }
                let orderToSet = (prevElementOrder + newOrder) / 2;
                reorderedData[index]["order"] = newOrder;
                reorderedData[1]["order"] = orderToSet;
                updateAttributeNode(reorderedData[index]._id, {
                    order: String(newOrder)
                });
                updateAttributeNode(reorderedData[1]._id, {
                    order: String(orderToSet)
                });
                // this.updateOrder(
                //     reorderedData[index].rel_id,
                //     newOrder,
                //     reorderedData[index].sysName
                // );
                // this.updateOrder(
                //     reorderedData[1].rel_id,
                //     orderToSet,
                //     reorderedData[1].sysName
                // );
                //console.log(prevElementOrder, orderToSet, index);
            } else {
                let prevItemOrder = parseInt(reorderedData[index - 1]["order"]);
                let nextItemOrder = parseInt(reorderedData[index + 1]["order"]);
                newOrder = (prevItemOrder + nextItemOrder) / 2;
                if (reorderedData[index + 1].isSystemAttribute === true) {
                    newOrder = prevItemOrder + 10000000000;
                }
                reorderedData[index]["order"] = newOrder;
                updateAttributeNode(reorderedData[index]._id, {
                    order: String(newOrder)
                });
                // this.updateOrder(
                //     reorderedData[index].rel_id,
                //     newOrder,
                //     reorderedData[index].sysName
                // );
            }
        } else {
            let firstOrder = reorderedData[0]["order"];
            let secondOrder = reorderedData[1]["order"];

            reorderedData[0]["order"] = secondOrder;
            reorderedData[1]["order"] = firstOrder;

            updateAttributeNode(reorderedData[0]._id, {
                order: String(secondOrder)
            });
            updateAttributeNode(reorderedData[1]._id, {
                order: String(firstOrder)
            });

            // bug solve
            // this.updateOrder(
            //     reorderedData[0].rel_id,
            //     secondOrder,
            //     reorderedData[0].sysName
            // );
            // this.updateOrder(
            //     reorderedData[1].rel_id,
            //     firstOrder,
            //     reorderedData[1].sysName
            // );
        }

        // for (let i = 0; i < reorderedData.length; i++) {
        //     reorderedData[i]["#"] = i + 1;
        // }

        draggedOverItemIndex = -1;
        activeItemIndex = -1;

        let allAttributes = [...reorderedData];

        if (!showSystemAttributes) {
            const systemAttributes = this.state.allAttributes.filter(
                (attr) => attr.isSystemAttribute
            );
            allAttributes.push(...systemAttributes);
        }

        this.setState({
            data: reorderedData,
            selectedId: this.state.oldSelectedId,
            draggedOverItemIndex,
            activeItemIndex,
            allAttributes,
        });
    }

    dragStart(dataItem) {
        var oldSelectedId = this.state.selectedId;
        this.setState({
            data: this.state.data,
            activeItem: dataItem,
            oldSelectedId: oldSelectedId,
            selectedId: dataItem._id,
            activeItemIndex: dataItem.index,
        });
    }

    // Update Side Date
    updateAttribute = (id, properties) => {
        let {
            allAttributes,
            data: prevData,
            showSystemAttributes,
        } = this.state;
        const systemAttributes = allAttributes.filter(
            (attr) => attr.isSystemAttribute
        );
        const userAttributes = allAttributes.filter(
            (attr) => !attr.isSystemAttribute
        );
        const attributeIndex = userAttributes.findIndex(
            (attr) => attr._id === id
        );
        userAttributes[attributeIndex] = {
            ...userAttributes[attributeIndex],
            ...properties,
        };
        let data = [...userAttributes];
        if (showSystemAttributes) {
            data = [...data, ...systemAttributes];
        }
        allAttributes = [...userAttributes, ...systemAttributes];
        const SideData = { ...userAttributes[attributeIndex] };
        this.setState({
            data,
            allAttributes,
            SideData,
        });
        this.props.showAction(data.length !== 0);
    };

    // Delete Attribute Part
    showDeleteAttributePopup = () => {
        this.setState({
            showDeletePopup: true,
            toDeleteId: this.state.selectedId
        });

        if (this.state.SideData.attributeType === "DateTime" || this.state.SideData.attributeType === "Number" || this.state.SideData.attributeType === "String") {
            this.setState({
                processingAttribute: true
            });
            this.findFormulaReferencesForAttribute(this.state.selectedId);
        } else {
            this.setState({
                processingAttribute: false,
                referenceAttr: [],
                referenceChecked: true
            })
        }
    };

    toggleDeleteAttributeDialog = (e) => {
        this.setState({ showDeletePopup: !this.state.showDeletePopup });
    };

    // getLinkedEntities = async () => {
    //     const { entityId } = this.props;
    //     // const index = this.state.data.findIndex(attr => attr._id === toDeleteId);
    //     this.setState({
    //         referenceAttr: [],
    //         referenceChecked: false
    //     });
    //     const checkFormulaRequest = await callApiWithAuthorization(
    //         "/api/v0/getLinkedEntities/" + entityId,
    //         {
    //             method: "GET",
    //             headers: {
    //                 "Content-Type": "application/json"
    //             }
    //         }
    //     )
    //     const checkFormulaResponse = await checkFormulaRequest.json();
    //     this.setState({
    //         referenceAttr: Array.from(new Set(checkFormulaResponse.message)),
    //         referenceChecked: true
    //     });
    // }

    findFormulaReferencesForAttribute = async (attributeId) => {
        const { entityId, entityName } = this.props;

        this.setState({
            referenceAttr: [],
            referenceChecked: false
        });

        const checkFormula = await findFormulaReferencesForAttribute({
            entityId,
            entityName,
            attributeId,
        });

        this.setState({
            referenceAttr: Array.from(new Set(checkFormula.message)),
            referenceChecked: true,
            processingAttribute: false
        });
    }

    checkBulkFormulaReferences = async (selectedAttributes) => {
        const { entityId, entityName } = this.props;
        const referenceBulkAttr = [];
        const formulaRequests = [];

        for (const attribute of selectedAttributes) {
            formulaRequests.push(
                findFormulaReferencesForAttribute({
                    entityId,
                    entityName,
                    attributeId: attribute._id,
                })
            );
        }

        const formulaResponses = await Promise.all(formulaRequests);

        for (const checkFormulaResponse of formulaResponses) {
            const uniqueReferences = Array.from(new Set(checkFormulaResponse.message));
            referenceBulkAttr.push(...uniqueReferences);
        }

        this.setState({
            referenceBulkAttr: referenceBulkAttr
        });
    }


    focusAttribute = async (attrId, entId, entName) => {
        if (attrId && attrId.length > 0) {
            const { project, organization, entityId, sysName } = this.props;
            if (entId != entityId) {
                const navigate = useNavigate();
                navigate(`/${organization.orgName}/${project.name}/Entities/${entName}/Attributes/${sysName}`);
            }
            else {
                this.rowClick(attrId);
            }
            this.setState({ showDeletePopup: false });
        }
    }
    deleteAttribute = async (e) => {
        this.deleteFormula();
        this.setState({ processingAttribute: true })
        const { target } = e;
        target.disabled = true;

        const { toDeleteId, data, allAttributes } = this.state;
        const { entityId } = this.props;
        const index = this.state.data.findIndex(attr => attr._id === toDeleteId);
        const attribute = this.state.data[index];
        if (attribute.attributeType === "State Field") {
            const statesToDelete = this.state.data[index].statefield;
            // await saveStatesForAttribute({
            //     attributeId: attribute._id,
            //     statesToCreate: [],
            //     statesToUpdate: [],
            //     statesToDelete: statesToDelete
            // })
        }

        const deleteResponse = await deleteAttribute(entityId, toDeleteId);

        const { deletedReferenceAttributeIds } = deleteResponse.data;

        await updateProject(this.props.project._id, { hasSchemaChanges: true });

        // filter out the deleted attribute
        // and also filter out the attributes that were deleted because of the reference
        const newData = data.filter(
            (attr) => {
                console.log(deletedReferenceAttributeIds.includes(attr._id), "THIS");
                return (
                    attr._id !== toDeleteId &&
                    !deletedReferenceAttributeIds.includes(attr._id)
                )
            }
        );
        const newAllAttributes = allAttributes.filter(
            (attr) =>
                attr._id !== toDeleteId &&
                !deletedReferenceAttributeIds.includes(attr._id)
        );

        this.setState({
            showDeletePopup: false,
            processingAttribute: false,
            toDeleteId: "",
            data: newData,
            allAttributes: newAllAttributes
        }, () => {
            if (newData.length > 0) {
                if (index === 0) {
                    this.rowClick(newData[index]._id);
                } else {
                    this.rowClick(newData[index - 1]._id);
                }
            } else {
                this.setState({ SideData: {} });
            }
        });
        this.props.showAction(data.length !== 0);
    }

    createSharedProperty = (data) => {
        this.createAttribute(data, false);
    }

    updateSharedPropertyAttribute = (sharedProperties, sharedLookupId) => {
        if (sharedLookupId === undefined) {
            this.setState({
                sharedProperties: [...sharedProperties]
            });
            return;
        }
        const { allAttributes, data: prevData } = this.state;
        const sharedProperty = sharedProperties.find(item => item._id === sharedLookupId);
        const index = allAttributes.findIndex(attr => attr.sharedLookupId === sharedProperty._id);
        if (index === -1) {
            this.setState({
                sharedProperties: [...sharedProperties]
            });
            return;
        }
        const newAllAttributes = allAttributes.map((attr, i) => {
            if (attr.sharedLookupId === sharedProperty._id) {
                return {
                    ...attr,
                    attributeName: sharedProperty.name,
                    attributeLabel: sharedProperty.name,
                    tooltip: sharedProperty.name,
                    languages: sharedProperty.attributeLanguages
                };
            }
            return attr;
        });
        const newData = prevData.map((attr, i) => {
            if (attr.sharedLookupId === sharedProperty._id) {
                return {
                    ...attr,
                    attributeName: sharedProperty.name,
                    attributeLabel: sharedProperty.name,
                    tooltip: sharedProperty.name,
                    languages: sharedProperty.attributeLanguages
                };
            }
            return attr;
        });
        const sideData = this.state.SideData && this.state.SideData.sharedLookupId === sharedLookupId ? {
            ...this.state.SideData,
            attributeName: sharedProperty.name,
            attributeLabel: sharedProperty.name,
            tooltip: sharedProperty.name,
            languages: sharedProperty.attributeLanguages
        } : this.state.SideData;
        this.setState({
            allAttributes: newAllAttributes,
            data: newData,
            sharedProperties: [...sharedProperties],
            SideData: sideData
        });
    }

    removeSharedPropertyAttribute = (sharedLookupId) => {
        const { data, allAttributes } = this.state;
        const index = data.findIndex(attr => attr.sharedLookupId === sharedLookupId);
        if (index === -1) {
            return;
        }
        const updatedData = data.filter(attr => attr.sharedLookupId !== sharedLookupId);
        const updatedAllAttributes = allAttributes.filter(attr => attr.sharedLookupId !== sharedLookupId);
        this.setState({
            data: updatedData,
            allAttributes: updatedAllAttributes
        }, () => {
            if (updatedData.length > 0) {
                if (index === 0) {
                    this.rowClick(updatedData[index]._id);
                } else {
                    this.rowClick(updatedData[index - 1]._id);
                }
            } else {
                this.setState({ SideData: {} });
            }
        });
    }

    createAttribute = (attribute, keepFormVisible) => {
        let { allAttributes, data } = this.state;
        data.push(attribute);
        allAttributes.push(attribute);

        if (this.state.showSystemAttributes) {
            const systemAttributes = data.filter(
                (attr) => attr.isSystemAttribute
            );
            const attributes = data.filter((attr) => !attr.isSystemAttribute);
            data = data.sort((a, b) => a.order - b.order);
            data = [...attributes, ...systemAttributes];
        }

        if (
            attribute.group.trim() !== "" &&
            !this.GroupData.includes(attribute.group)
        ) {
            this.GroupData.push(attribute.group);
            this.GroupData = [...new Set(this.GroupData)];
        }

        const groupData = this.state.data
            .map((d) => d.group)
            .filter((group) => group.trim() !== "");
        const groups = [...new Set(groupData)];
        this.GroupData = groups;

        this.setState(
            {
                data: data,
                allAttributes: allAttributes,
                showNewAttributeDialog: keepFormVisible,
            },
            () => {
                this.rowClick(attribute._id);
            }
        );
        this.props.showAction(data.length !== 0);
    };

    //Recommendation Page
    toggleAliceGPTDialog = () => {
        this.setState({
            showAliceGPTDialog: !this.state.showAliceGPTDialog,
        });
    }

    getExistingAttributeNames = () => {
        const { data } = this.state;
        return data.map((attr) => attr.attributeName);
    }

    hasStateAttribute = () => {
        return this.state.data.find(attr => attr.attributeType === "State Field");
    }

    addImportAttributesToGrid = (attributes) => {
        if (attributes.status && attributes.status === "Failure") {
            this.toggleUpgradeDailog();
            return;
        }
        const { allAttributes, data, showSystemAttributes } = this.state;
        let newData = [];
        attributes.data.forEach(this.setAttributeProperties)
        const failureResponses = attributes.data.filter(attr => attr.status === "Failure" && attr.message === "Max Attributes allowed limit reached");
        const attributesToAdd = attributes.data.filter(attr => attr.status !== "Failure" && attr.message !== "Max Attributes allowed limit reached");
        if (showSystemAttributes) {
            const systemAttributes = allAttributes.filter(attr => attr.isSystemAttribute);
            newData = data.filter(attr => !attr.isSystemAttribute);
            newData.push(...attributesToAdd);
            newData.push(...systemAttributes);
        } else {
            newData = [...data, ...attributesToAdd].sort((a, b) => a.order - b.order);
        }
        allAttributes.push(...attributesToAdd);
        if (failureResponses.length > 0) {
            this.toggleUpgradeDailog();
        }
        this.setState({
            allAttributes,
            data: newData,
        }, () => {
            if (attributes.data.length > 0 && attributes.data[0] && attributes.data[0]._id) {
                this.rowClick(attributes.data[0]._id);
            }
        });
    }
}

export default withTranslation([
    "attribute/common",
    "attribute/attribute_type",
    "attribute/create_dialog"
], {
    withRef: true
})(AttributeComponent);
